<template>
  <handsontable :data="data" :settings="settings"></handsontable>
</template>

<script>
import Handsontable from 'vue-handsontable'

var defaultColumns = [
  { data: 'first_name' },
  { data: 'last_name' },
  { data: 'date_of_birth', 'type': 'date' },
  { data: 'gender', 'type': 'dropdown', 'source': ['M', 'F'] }
]

export default {
  components: {
    Handsontable
  },
  props: {
    grid: String,
    columns: String,
    reg_num: false,
    categories: String
  },
  methods: {
    toTitleCase: function (str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    },
    colHeaders: function (colz) {
      var self = this
      var o = colz.map(function (i) {
        return self.toTitleCase(i.data.split('_').join(' '))
      })
      return o
    }
  },
  data () {
    var cols = defaultColumns
    var catColumn = {}
    var cats = null
    if (this.reg_num) {
      cols.unshift({ data: 'reg_num', type: 'numeric' })
    }
    if (this.categories) {
      cats = JSON.parse(this.categories)
      catColumn = {data: 'category'}
      if (typeof cats !== 'boolean') {
        catColumn.type = 'dropdown'
        catColumn.source = cats
      }
      cols.push(catColumn)
    }
    var setts = {}
    if (typeof this.grid !== 'undefined') {
      setts = { data: JSON.parse(this.grid), settings: {} }
    } else {
      setts = {
        settings: { columns: cols, colHeaders: this.colHeaders(cols), minSpareRows: 2 },
        data: []
      }
    }
    return setts
  }
}
</script>

<style>
    [v-cloak] { display: none }
<style>



// WEBPACK FOOTER //
// DemoHandsOn.vue?6d235ac0